import { render, staticRenderFns } from "./DaisoVideo.vue?vue&type=template&id=b7c1ec74&scoped=true&"
import script from "./DaisoVideo.vue?vue&type=script&lang=js&"
export * from "./DaisoVideo.vue?vue&type=script&lang=js&"
import style0 from "./DaisoVideo.vue?vue&type=style&index=0&id=b7c1ec74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c1ec74",
  null
  
)

export default component.exports